import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'


import { fetchHomepageIfNeeded } from '../../actions'
import { ROOT_ROUTE, ROOT_ROUTE_CALENDAR } from '../../constants/auth'
import Spinner from '../../components/Spinner'
import Profile from '../../classes/profile'
import { LS_HOMEPAGE_KEY } from '../../constants/local_storage'
import DateHelpers from '../../classes/DateHelpers'

/** Deals with logic around authorization callback
 *
 * Mostly this just toggles between redirecting somewhere and showing a page indicating you're logging in.
 */
class LoginCallbackContainer extends React.Component {
  static propTypes = {
    isLoggingIn: PropTypes.bool.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    nextPath: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    profile: Profile.PropTypes,
    homepage: PropTypes.object,
    fetchHomepage: PropTypes.func.isRequired
  }

  componentDidUpdate (prevProps) {
    if (prevProps.isLoggedIn && !this.props.isLoggingIn && prevProps.profile !== !this.props.profile && prevProps.homepage !== !this.props.homepage && this.props.homepage?.details) {
      this.setState({redirectTo: this.props.nextPath})
    }
    if (prevProps.profile !== !this.props.profile) {
      const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
      if (!homepage) {
        if (this.props.profile && this.props.profile.groups.length > 0) {
          const groups = this.props.profile.groups
          const groupName = groups.filter(group => group !== 'Admin')[0]
          this.props.fetchHomepage(groupName)
        }
      }
    }
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (this.props.isLoggingIn && !nextProps.isLoggingIn && this.props.profile !== !nextProps.profile && nextProps.homepage?.details) {
      this.setState({redirectTo: nextProps.nextPath})
    }
  }

  render () {
    if (this.state && this.state.redirectTo && this.props.homepage?.details?.is_attention_index) {
      return (<Redirect to={this.state.redirectTo} />)
    } else if (this.props.isLoggedIn && this.props.homepage?.details?.is_attention_index === true) {
      return (<Redirect to={ROOT_ROUTE} />)
    } else if (this.props.isLoggedIn && this.props.homepage?.details?.is_attention_index === false) {
      const currentDateStr = DateHelpers.getDateString(new Date())
      return (<Redirect to={`${ROOT_ROUTE_CALENDAR}/${currentDateStr}`} />)
    } else {
      return (<Spinner />)
    }
  }
}

function mapStateToProps () {
  return (state) => {
    const {isLoggingIn, isLoggedIn, nextPath} = state.user
    const profile = state.user.profile && new Profile(state.user.profile)
    const homepage = state.homepage.list
    return {
      isLoggingIn,
      isLoggedIn,
      nextPath,
      profile,
      homepage
    }
  }
}

function mapDispatchToProps (dispatch) {
  return {
    fetchHomepage: (groupName) => dispatch(fetchHomepageIfNeeded(groupName))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginCallbackContainer)
